import React from 'react';
import ButtonBase from '@material-ui/core/ButtonBase';
import AddRounded from '@material-ui/icons/AddRounded';

import { merge } from '../../../../../utils';
import { subTitle1, black } from '../../../../../resources/styles';
import { withResizer } from '../../../../../HoCs';
import Component from '../../../../../ui-components/Component';
import styles from './styles';
import pages,{ getRouteForPage } from '../../../../../PageEnums';
import { Link } from 'react-router-dom';
import { showErrorSnack } from '../../../../../ui-components/utils';

class OyoAddCard extends Component {

    styles = styles;


    render = () => {
        let gc = this.props.gc;
        const { style, className } = this.props;
        return <div style={merge(this.gs('add_container'), style)} className={className}>
            <div style={merge(subTitle1, black)}>{gc('want_to_associate')}{'?'}</div>
            <Link
                style={this.gs('add_property_wrapper')}
                to={getRouteForPage(pages.PROPERTIES,'new')}
            >
            <ButtonBase style={merge(this.gs('add_property'), { marginTop: 16 })}>
                <AddRounded style={this.gs('add_icon')} />{gc('add_a_property')}
            </ButtonBase>
            </Link>
        </div>;

    }

}

export default withResizer(OyoAddCard);